import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class ModelIntervalModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (ModelIntervalModel._instance == null) ModelIntervalModel._instance = new ModelIntervalModel(authManager);
        return ModelIntervalModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'model-sections/model-intervals');

        this.entityName = 'model-sections.ModelInterval';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Model Interval';
        this.setLabel = 'Model Intervals';

        this.browser = {
            name: 'default-model-sections-modelinterval-browser',
            moduleName: 'default-model-sections-modelinterval-browser',
            moduleTitle: 'Model Intervals',
            moduleStateSlotName: 'default-model-sections-modelinterval-browser',
        };

        this.editor = {
            name: 'default-model-sections-modelinterval-editor',
            moduleName: 'default-model-sections-modelinterval-editor',
            moduleTitle: 'Model Interval',
            moduleStateSlotName: 'default-model-sections-modelinterval-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                description: '(zajistit jedinečnost v rámci Code/Standard/Project)',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'modelSectionId',
                type: 'ModelSection',
                persistent: true,
                label: 'Model Section',
                description: 'only for info (check)',
            },
            {
                name: 'elevationTop',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Elevation Top',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'elevationBottom',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Elevation Bottom',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'elevationOfZeroDatumLevel',
                type: 'float',
                persistent: false,
                unit: 'masl',
                label: 'Elevation Of Zero Datum Level',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'verticalLevelTop',
                type: 'float',
                persistent: true,
                unit: 'm',
                label: 'Vertical Level Top',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'verticalLevelBottom',
                type: 'float',
                persistent: true,
                unit: 'm',
                label: 'Vertical Level Bottom',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'thickness',
                type: 'float',
                persistent: true,
                unit: 'm',
                label: 'Thickness',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'isModelSectionTopInterval',
                type: 'bool',
                persistent: true,
                label: 'Is Model Section Top Interval',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'isModelSectionBottomInterval',
                type: 'bool',
                persistent: true,
                label: 'Is Model Section Bottom Interval',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'geoSectionId',
                type: 'GeoSection',
                persistent: true,
                label: 'Geo Section',
                description: 'geoLayer odpovídá vždy jen jedné geoSection, n:1',
                readOnly: true,
                inEditor: true,
            },
            {
                name: 'geoLayerId',
                type: 'GeoLayer',
                persistent: true,
                label: 'Geo Layer',
                readOnly: true,
                inEditor: true,
            },
            {
                name: 'waterBodyId',
                type: 'WaterBody',
                persistent: true,
                label: 'Water Body',
                description: 'reference to particular water body',
                readOnly: true,
            },
            {
                name: 'waterBodyTypeId',
                type: 'WaterBodyType',
                persistent: false,
                label: 'Water Body Type',
                description: 'reference to particular water body type',
                readOnly: true,
            },
            {
                name: 'waterUnitWeightGamaW',
                type: 'float',
                persistent: false,
                unit: 'kN/m^3',
                label: 'Water Unit Weight Gama W',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'waterBodyElevationTop',
                type: 'float',
                persistent: false,
                unit: 'masl',
                label: 'Water Body Elevation Top',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'waterBodyPressureUzTop',
                type: 'float',
                persistent: false,
                unit: 'kPa',
                label: 'Water Body Pressure Uz Top',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'waterBodyPressureIncreaseCoefKzInc',
                type: 'float',
                persistent: false,
                unit: 'kN/m^3',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'isWithinWaterBody',
                type: 'bool',
                persistent: true,
                label: 'Is Within Water Body',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'hasBuoyancyEffectWhenUnderWater',
                type: 'bool',
                persistent: true,
                label: 'Has Buoyancy Effect When Under Water',
                description: '(Except Capillary Water)',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'isWithinWaterBodyAndHasBuoyancyEffect',
                type: 'bool',
                persistent: true,
                label: 'Is Within Water Body And Has Buoyancy Effect',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'waterIntervalTopDepth',
                type: 'float',
                persistent: true,
                unit: 'm',
                label: 'Water Interval Top Depth',
                description: 'depth of top of interval with water from the water body surface',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'waterIntervalBottomDepth',
                type: 'float',
                persistent: true,
                unit: 'm',
                label: 'Water Interval Bottom Depth',
                description: 'depth of bottom of interval with water from the water body surface',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'isWaterBodySurface',
                type: 'bool',
                persistent: true,
                label: 'Is Water Body Surface',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'waterIntervalPressureUzTop',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'waterIntervalIncreaseUzInc',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'waterIntervalPressureUzBottom',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'geoTypeId',
                type: 'GeoType',
                persistent: false,
                readOnly: true,
            },
            {
                name: 'k0CalcMethodId',
                type: 'K0CalculationMethod',
                persistent: false,
                label: 'K 0 Calc Method',
                description: '(coefficient of lateral earth pressure at rest)',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'coefficientOfLateralEarthPressureAtRestK0',
                type: 'float',
                persistent: false,
                unit: '1',
                label: 'Coefficient Of Lateral Earth Pressure At Rest K 0',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'bulkUnitWeightGama',
                type: 'float',
                persistent: false,
                unit: 'kN/m^3',
                label: 'Bulk Unit Weight Gama',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'dryUnitWeightGamaD',
                type: 'float',
                persistent: false,
                unit: 'kN/m^3',
                label: 'Dry Unit Weight Gama D',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'saturatedUnitWeightGamaSat',
                type: 'float',
                persistent: false,
                unit: 'kN/m^3',
                label: 'Saturated Unit Weight Gama Sat',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'degreeOfSaturationSr',
                type: 'float',
                persistent: false,
                unit: '1',
                label: 'Degree Of Saturation Sr',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'moistureContentW',
                type: 'float',
                persistent: false,
                unit: '%',
                label: 'Moisture Content W',
                description: 'Moisture (Water) Content Chosen Value',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'effectiveInternalFrictionAngleFiEf',
                type: 'float',
                persistent: false,
                unit: 'deg',
                label: 'Effective Internal Friction Angle Fi Ef',
                description: 'Effective Internal Friction Angle',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'effectiveCohesionCef',
                type: 'float',
                persistent: false,
                unit: 'kPa',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'isModelSectionMassTopInterval',
                type: 'bool',
                persistent: true,
                label: 'Is Model Section Mass Top Interval',
                description: 'is interval the top soil mass or rock mass of the model ?',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'loadId',
                type: 'GeoLoad',
                persistent: true,
                label: 'Load',
            },
            {
                name: 'continuousUniformVerticalLoadP',
                type: 'float',
                persistent: false,
                unit: 'kPa',
                label: 'Continuous Uniform Vertical Load P',
                description: 'at top of interval',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'boundaryId',
                type: 'GeoBoundary',
                persistent: true,
            },
            {
                name: 'objectId',
                type: 'GeoObject',
                persistent: true,
                label: 'Object',
                description: 'pomocný sloupec',
            },
        ];

    }

}
